var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongRightArrowicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M693.846-313.847 651.078-356l94-94.001H140.001v-59.998h605.077L651.693-604l42.768-42.153L859.999-480 693.846-313.847Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongRightArrowicon);
export default __webpack_public_path__ + "static/media/longRightArrow.icon.df07867034116faf762e044222f228d5.svg";
export { ForwardRef as ReactComponent };